import { render, staticRenderFns } from "./CustomerTaxPanel.vue?vue&type=template&id=45e5e149"
import script from "./CustomerTaxPanel.vue?vue&type=script&lang=js"
export * from "./CustomerTaxPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports